export default __webpack_public_path__ + "static/media/Singhal.68c17059.png";